import React from 'react';
import LargeHeading from "../components/LargeHeading";
import FlatPanel from "../components/FlatPanel";
import Spacer from '../components/Spacer';

const WhatIDo = (props) => {

    return (
        <section className="what-i-do" {...props}>
            <div className="panels">
                <div className="inner">
                    <FlatPanel id="client-panel">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><title>Skills - client</title><path d="M71.53,56.55a18.85,18.85,0,0,0-1.19-1.67A20.35,20.35,0,0,0,68,52.24a23.45,23.45,0,0,0-2.76-2.36,25.27,25.27,0,0,0-15.47-5.19,25.63,25.63,0,0,0-20.38,10c-.45.58-.88,1.19-1.3,1.82A25.86,25.86,0,0,0,24,70.47V82.6a4.54,4.54,0,0,0,4.55,4.55H71a4.54,4.54,0,0,0,4.55-4.55V70.47a25.78,25.78,0,0,0-4.06-13.92Zm-8.07-30A13.65,13.65,0,1,1,49.81,12.85,13.67,13.67,0,0,1,63.46,26.5Zm28.81,0A13.65,13.65,0,1,1,78.63,12.85,13.66,13.66,0,0,1,92.27,26.5Zm6.07,37.9V76.54a4.54,4.54,0,0,1-4.55,4.54H80.14V70.47a30.46,30.46,0,0,0-4.76-16.34c-.46-.7-.94-1.37-1.33-1.88A24.65,24.65,0,0,0,71.25,49c-.69-.69-1.39-1.33-2.09-1.91A19.7,19.7,0,0,1,98.34,64.4ZM30.49,47.12a30.07,30.07,0,0,0-4.64,4.79c-.51.67-1,1.37-1.54,2.19a30.07,30.07,0,0,0-4.83,16.37V81.08H5.83a4.54,4.54,0,0,1-4.54-4.55V64.41a19.72,19.72,0,0,1,29.2-17.29ZM34.65,26.5A13.65,13.65,0,1,1,21,12.85,13.67,13.67,0,0,1,34.65,26.5Z"/></svg>
                    </FlatPanel>
                    <FlatPanel id="server-panel">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><title>Skills - server</title><path d="M85.51,6.42H13.4a12.56,12.56,0,0,0,0,25.12H85.52a12.56,12.56,0,0,0,0-25.12Zm-.05,17A4.43,4.43,0,1,1,89.91,19,4.43,4.43,0,0,1,85.46,23.41Zm.05,14H13.4a12.56,12.56,0,0,0,0,25.12H85.52a12.56,12.56,0,0,0,0-25.12Zm-.05,17A4.43,4.43,0,1,1,89.91,50a4.43,4.43,0,0,1-4.45,4.43Zm.05,14H13.4a12.56,12.56,0,0,0,0,25.12H85.52a12.56,12.56,0,0,0,0-25.12Zm-.05,17A4.44,4.44,0,1,1,89.91,81,4.44,4.44,0,0,1,85.46,85.45Z"/></svg>
                    </FlatPanel>
                    <FlatPanel id="misc-panel">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><title>Skills - mid</title><path d="M76.43,23.33A37.38,37.38,0,0,0,12.62,49.77H.16L17.29,68.46,34.43,49.77H22A28,28,0,0,1,69.83,30a4.67,4.67,0,0,0,6.6-6.62ZM23.57,76.21A37.38,37.38,0,0,0,87.38,49.77H99.84L82.71,31.08,65.57,49.77H78A28,28,0,0,1,30.17,69.59a4.67,4.67,0,0,0-6.6,6.62Z"/></svg>
                    </FlatPanel>
                </div>
            </div>
            <div className="content-container">
                <div className="heading-container">
                    <LargeHeading title="The Stack" />
                    <div className="trigger" />
                </div>
                <Spacer height="100vh" />
                <div className="info client-container" id="client-container">
                    <h2>Frontend</h2>
                    <ul>
                        <li>React, React Native & Node.js</li>
                        <li>TypeScript</li>
                        <li>Tailwind CSS, CSS Modules & SASS</li>
                        <li>Gatsby JS & GraphQL</li>
						<li>GSAP animation</li>
						<li>JAM Stack (Headless CMS, SSR etc)</li>
                        <li>UI/UX Design</li>
                        <li>npm & Webpack</li>
						<li>AJAX & API integration</li>
                        <li>SEO & CRO</li>
						<li>Performance optimisation</li>
                        <li>JAM stack (Headless CMS, SSR etc)</li>
                    </ul>
                </div>
                <Spacer height="100vh" />
                <div className="info server-container" id="server-container">
                    <h2>Backend</h2>
                    <ul>
                        <li>Software architecture</li>
                        <li>Building microservices</li>
                        <li>Node.js</li>
                        <li>PHP (OOP & MCV) & Laravel</li>
                        <li>MySQL database development</li>
						<li>API development</li>
                        <li>CMS development</li>
                        <li>Business systems development</li>
                        <li>Git & CI/CD systems</li>
                        <li>LAMP stack</li>
                    </ul>
                </div>
                <Spacer height="80vh" />
                <div className="info misc-container" id="misc-container">
                    <h2>Also</h2>
                    <ul>
                        <li>Management skills & experience</li>
						<li>Technical leadership & mentoring</li>
                        <li>Project management (ClickUp & JIRA)</li>
						<li>Experience working fully remote</li>
						<li>Analytics & event tracking</li>
                        <li>My sense of humour <span className="emoji" role="img" aria-label="Wink">😉</span></li>
                    </ul>
                </div>
            </div>
        </section>
    );

};

export default WhatIDo;


// WEBPACK FOOTER //
// ./src/js/views/WhatIDo.js